import * as React from 'react';

import {
  VoiceboxMessage,
  VoiceboxRequestMessage,
} from 'bones/constants/voicebox/message';

export const useGetMessageContext = (messages: VoiceboxMessage[]) => {
  return React.useCallback(
    (messageId: string) => {
      const messageIdx = messages.findIndex(
        (message) => message.messageId === messageId
      );
      const prevRequestMessage = messages
        .slice(0, messageIdx)
        .reverse()
        .find((message): message is VoiceboxRequestMessage =>
          Boolean(message.isRequest)
        );

      return prevRequestMessage?.context || /* istanbul ignore next */ {};
    },
    [messages]
  );
};
